export const cityOptions = [
  { id: 'cities', name: 'Helsinki', optionId: '4b4d2d82-fa06-42e9-a0f2-dfe5ffb5ed09' },
  { id: 'cities', name: 'Sipoo', optionId: '8ce1ad20-e503-462b-bf7f-b14097e3f455' },
  { id: 'cities', name: 'Porvoo', optionId: '427205dd-5691-4bbb-b493-bc8797e1ae15' },
  { id: 'cities', name: 'Vantaa', optionId: '12a3a629-bd03-4336-8ce6-c63f26baa9f0' },
  { id: 'cities', name: 'Nurmijärvi', optionId: '6ac15702-86a7-46af-86aa-8cb883479bb7' },
  { id: 'cities', name: 'Espoo', optionId: '715c76b8-8906-4527-94f9-fb8e73853c97' },
  { id: 'cities', name: 'Kirkkonummi', optionId: 'd71cec9b-7180-463c-a04e-33e568e64364' },
  { id: 'cities', name: 'Siuntio', optionId: '25d73dc6-389b-4786-8ada-7f0ab8933b48' },
  { id: 'cities', name: 'Kauniainen', optionId: 'a89dd957-a89d-47b8-9e0d-90bbe88326b2' },
  { id: 'cities', name: 'Vihti', optionId: '4171cfe1-5ac7-4efc-a545-0d31cc5fbe59' },
  { id: 'cities', name: 'Karkkila', optionId: 'ab2b9354-887c-4f01-bb32-382a7c86c786' },
  { id: 'cities', name: 'Lohja', optionId: 'f16b5caa-ef26-4135-9849-fc7ad69fbaea' },
  { id: 'cities', name: 'Kerava', optionId: 'dff7df7d-a3e7-4a41-a882-f4b1f81e01be' },
  { id: 'cities', name: 'Tuusula', optionId: 'aa287e60-6c5d-45c3-90e2-af2c572e03b6' },
  { id: 'cities', name: 'Järvenpää', optionId: 'f603ec52-d7b9-4017-855c-bc088d910a6f' },
  { id: 'cities', name: 'Mäntsälä', optionId: 'ab58e176-1869-4358-9f19-74c62995a29f' },
  { id: 'cities', name: 'Hyvinkää', optionId: '44ed37c6-daf2-44a4-a21b-9792c0b92176' },
  { id: 'cities', name: 'Pornainen', optionId: '051a00a0-a928-4b80-809a-2ce868ad7910' },
  { id: 'cities', name: 'Askola', optionId: '6923c305-5b4f-4477-9fb5-1cd5aee5fd23' },
  { id: 'cities', name: 'Pukkila', optionId: 'd6ffc19e-ba6f-48d4-a663-bfe1090c7c66' },
  { id: 'cities', name: 'Myrskylä', optionId: '10c0af94-7ce4-415e-ba7a-aa8de238b41d' },
  { id: 'cities', name: 'Loviisa', optionId: '2ca027dd-1aa0-47fd-92cb-6829ffbc47db' },
  { id: 'cities', name: 'Lapinjärvi', optionId: 'b76c8961-e68d-4592-927c-2664fee1dfbd' },
  { id: 'cities', name: 'Inkoo', optionId: '56e80337-91e5-4b2c-ac54-e396f600471e' },
  { id: 'cities', name: 'Raasepori', optionId: 'ba9efd72-a9db-4e4d-8bf6-3acd235b7875' },
  { id: 'cities', name: 'Hanko', optionId: 'bf6385bd-5573-4347-85b4-e24ae8f400b2' },
  { id: 'cities', name: 'Riihimäki', optionId: '0ffabf9d-041f-454b-93ab-4baeeacef25e' },
  { id: 'cities', name: 'Janakkala', optionId: 'd0d31067-bf9f-4540-bd91-248233c7b6c8' },
  { id: 'cities', name: 'Hausjärvi', optionId: 'e446d196-7e1f-499a-90e7-6802955d2c25' },
  { id: 'cities', name: 'Loppi', optionId: 'f04874a4-06e1-4542-bb76-2ac5481e626a' },
  { id: 'cities', name: 'Hämeenlinna', optionId: '1a6d3077-4e8e-4ff6-8e9d-e2f944a1332d' },
  { id: 'cities', name: 'Hattula', optionId: '46b51d21-b031-4638-a41e-5da33b831e8d' },
  { id: 'cities', name: 'Forssa', optionId: '206b0249-4fad-4f3b-bcac-15e81864ae8a' },
  { id: 'cities', name: 'Tammela', optionId: 'db652db4-1ae9-4880-89c8-f1ebdaab8f6b' },
  { id: 'cities', name: 'Jokioinen', optionId: '481ffacf-cce4-4642-a546-5885eae1d096' },
  { id: 'cities', name: 'Humppila', optionId: 'ce3ed07f-28da-42f4-afea-7024890b5fa3' },
  { id: 'cities', name: 'Ypäjä', optionId: '5dd07863-6ecf-40a0-ba7d-04e681df2fea' },
  { id: 'cities', name: 'Pälkäne', optionId: 'b09794a6-3a8b-43f0-ae30-c5f4b0d553cb' },
  { id: 'cities', name: 'Urjala', optionId: '13ac368d-0629-4e11-94de-6028424254f0' },
  { id: 'cities', name: 'Punkalaidun', optionId: 'e9056c6c-29de-4cf5-bad2-b8e8b9da8951' },
  { id: 'cities', name: 'Sastamala', optionId: '36ca8d79-6a30-4b7c-9edf-a71bb836d29f' },
  { id: 'cities', name: 'Tampere', optionId: 'a62a9fe2-2991-45d0-ba21-f53416cb816f' },
  { id: 'cities', name: 'Nokia', optionId: 'a5e105e4-aad2-47ff-94a1-b4cb17eb1a16' },
  { id: 'cities', name: 'Ylöjärvi', optionId: 'dc65105a-c775-41c7-a445-a6878657007d' },
  { id: 'cities', name: 'Lempäälä', optionId: 'ce40dd57-4723-41b9-822c-79d5980df95b' },
  { id: 'cities', name: 'Pirkkala', optionId: '606a2e9d-25c9-4f17-846e-bf431c7d8cf9' },
  { id: 'cities', name: 'Ruovesi', optionId: '1f69e489-a8c1-4c89-8d0f-ef7c43978894' },
  { id: 'cities', name: 'Virrat', optionId: '7ce287f7-f657-416d-9fb3-f0c6b865bcc0' },
  { id: 'cities', name: 'Orivesi', optionId: '979c0f3c-d6ef-47cb-bbf8-c949da57bee0' },
  { id: 'cities', name: 'Juupajoki', optionId: 'a822257d-bdf3-4bcb-b437-fc510eabd769' },
  { id: 'cities', name: 'Mänttä-Vilppula', optionId: 'cc3a4470-10c2-4e50-9950-a60fe6b0a987' },
  { id: 'cities', name: 'Kangasala', optionId: 'e76aee7d-07f5-4166-b02a-6d5363ebde2d' },
  { id: 'cities', name: 'Vesilahti', optionId: '2ecfbf22-cb68-4c61-b48d-84729a567865' },
  { id: 'cities', name: 'Valkeakoski', optionId: '1a2df592-5e82-43a6-9a5f-1f79682f2db3' },
  { id: 'cities', name: 'Akaa', optionId: '797e3603-e4f8-4a22-a69a-7c1220b2974e' },
  { id: 'cities', name: 'Hämeenkyrö', optionId: '9327a8fe-a924-43fb-9750-0f2a1712a1c6' },
  { id: 'cities', name: 'Ikaalinen', optionId: '550c4bf0-27c5-4993-a865-c4ef803baac2' },
  { id: 'cities', name: 'Parkano', optionId: 'fe6abf7a-c18d-4428-b90d-1dffe6495624' },
  { id: 'cities', name: 'Kihniö', optionId: 'e6618f3e-be12-4b7a-b3b3-2c0fe5c7e6b4' },
  { id: 'cities', name: 'Lahti', optionId: '8c90e957-dd53-4bb5-8702-4333dfac0c92' },
  { id: 'cities', name: 'Hollola', optionId: '491af09a-08df-4a7f-b295-455c27957947' },
  { id: 'cities', name: 'Orimattila', optionId: 'ec22a5c0-9bd2-48df-9912-3c1f467fe213' },
  { id: 'cities', name: 'Kärkölä', optionId: '66da4277-c3da-4520-8307-7adbe666ac1d' },
  { id: 'cities', name: 'Asikkala', optionId: '60087235-aed5-4828-a5fe-19d61c07c38a' },
  { id: 'cities', name: 'Padasjoki', optionId: '7cdb3cdb-08d4-4d61-b4ca-a003e5f77c42' },
  { id: 'cities', name: 'Heinola', optionId: '550a1e75-1c0a-41cb-9765-40d4d5af831f' },
  { id: 'cities', name: 'Sysmä', optionId: 'e188ec10-b99d-477c-a271-332dde601918' },
  { id: 'cities', name: 'Hartola', optionId: '84262621-622e-4ce0-b568-82250d74e644' },
  { id: 'cities', name: 'Kuhmoinen', optionId: 'ca86bacc-740d-4553-9df6-298417c5cf6c' },
  { id: 'cities', name: 'Joutsa', optionId: 'bafef369-8aca-484f-acf2-613f9dc6efc9' },
  { id: 'cities', name: 'Luhanka', optionId: '242d2e35-bddc-4467-9ab4-338568592b6e' },
  { id: 'cities', name: 'Jämsä', optionId: '92c4a25b-eac8-4a22-a571-77740c8d352a' },
  { id: 'cities', name: 'Jyväskylä', optionId: '2b3ebfc4-ed96-4725-9839-288c243ade6c' },
  { id: 'cities', name: 'Muurame', optionId: 'c80a8c82-ad03-4b40-9fc6-9629212af75e' },
  { id: 'cities', name: 'Laukaa', optionId: '0f79cdbc-3106-4d69-8a2a-d9f0baf4d677' },
  { id: 'cities', name: 'Uurainen', optionId: 'ecb74bba-9276-4376-b2c8-443dc7a163f4' },
  { id: 'cities', name: 'Saarijärvi', optionId: 'b5489d63-5809-4027-b4c3-f502bc287559' },
  { id: 'cities', name: 'Toivakka', optionId: 'a2994893-0901-4d98-9b60-4c4068862617' },
  { id: 'cities', name: 'Hankasalmi', optionId: 'ac15dffe-b2ff-4d32-8a41-7c40637d50a6' },
  { id: 'cities', name: 'Petäjävesi', optionId: 'f19eaabf-d0d1-4797-bbae-a0fa1590e5bb' },
  { id: 'cities', name: 'Keuruu', optionId: 'efb0ecd8-07b9-4fda-abdf-f456e8ceb5d2' },
  { id: 'cities', name: 'Multia', optionId: '97dde06e-bc97-4e19-b509-20efcecc964c' },
  { id: 'cities', name: 'Kannonkoski', optionId: '92ea6079-d8e1-44a4-8361-00949ed5091c' },
  { id: 'cities', name: 'Kivijärvi', optionId: '16b6c628-8bfa-44f3-932c-5b56edc59424' },
  { id: 'cities', name: 'Karstula', optionId: '0bd08ea3-a459-4f14-b23e-01109aec2ed5' },
  { id: 'cities', name: 'Kyyjärvi', optionId: '83589812-6bfb-49d8-a63a-cae6f3684b87' },
  { id: 'cities', name: 'Kinnula', optionId: '55459163-e8d3-4584-b53b-b85b6f356f05' },
  { id: 'cities', name: 'Äänekoski', optionId: '5016e515-0251-4c83-9b1d-b5052fbea0c0' },
  { id: 'cities', name: 'Konnevesi', optionId: '42d2fffd-f82b-4c23-846e-d5b8b911b947' },
  { id: 'cities', name: 'Viitasaari', optionId: 'fdeb45b9-980e-4fc9-9111-55329c432eac' },
  { id: 'cities', name: 'Pihtipudas', optionId: '0d177da7-b23c-417a-bc1f-eb5834f73b43' },
  { id: 'cities', name: 'Iitti', optionId: 'aa9f9d0f-fec5-487b-b7a4-b730189ba827' },
  { id: 'cities', name: 'Kouvola', optionId: '75d3e122-e516-4ab0-bf2b-a3ff1e1007f5' },
  { id: 'cities', name: 'Kotka', optionId: 'f4b0a5bb-2833-446e-abcb-f6beeab71c2f' },
  { id: 'cities', name: 'Pyhtää', optionId: 'b3bcd862-d82e-421e-b051-d4b4b825fadc' },
  { id: 'cities', name: 'Hamina', optionId: '45d154f0-b5f4-4110-b955-ddda5be0e371' },
  { id: 'cities', name: 'Miehikkälä', optionId: '2be1c153-fe77-47bb-b895-7ca53a405aea' },
  { id: 'cities', name: 'Virolahti', optionId: 'f7d4b8d5-0b84-41a5-bb3e-c4846774948d' },
  { id: 'cities', name: 'Pertunmaa', optionId: '0eb66e7f-aea8-4e8c-ab60-4df3bb1a5300' },
  { id: 'cities', name: 'Mikkeli', optionId: 'f41922e9-e9c7-4ba1-9335-a6f798e2c6ca' },
  { id: 'cities', name: 'Kangasniemi', optionId: 'ef6c1a39-168f-49b3-86b7-e0c0f38c243e' },
  { id: 'cities', name: 'Juva', optionId: 'cbe2da65-0b5e-4365-bc4f-26a064f2a2f7' },
  { id: 'cities', name: 'Puumala', optionId: '51d81929-aa69-4d62-b3f3-11fccd90e96e' },
  { id: 'cities', name: 'Hirvensalmi', optionId: '2fa697a5-3bc6-499d-ab0e-33c175cb1a8f' },
  { id: 'cities', name: 'Mäntyharju', optionId: '74e77515-e892-47ff-9964-c7ee31ad8eab' },
  { id: 'cities', name: 'Savonlinna', optionId: 'accf3775-0816-4a68-8eab-3c75aa6f7146' },
  { id: 'cities', name: 'Enonkoski', optionId: 'c1b1ae2d-e1a3-4681-95d0-10f754d5fb8f' },
  { id: 'cities', name: 'Sulkava', optionId: '407be629-06a2-4baf-b11a-293c4ce5ae44' },
  { id: 'cities', name: 'Rantasalmi', optionId: 'f9614e47-4e8f-4372-a545-a646a9b4a5ca' },
  { id: 'cities', name: 'Pieksämäki', optionId: 'e8e4ac5f-f15a-4720-8815-bb77cec78cda' },
  { id: 'cities', name: 'Joroinen', optionId: '5187d3bd-44bc-44c8-bef7-b3c0fdb45bcf' },
  { id: 'cities', name: 'Heinävesi', optionId: '49d9395b-58dd-4815-bedd-fffe15c8ac99' },
  { id: 'cities', name: 'Turku', optionId: '9c869bae-94b7-4b02-8fc5-5371d80ece1e' },
  { id: 'cities', name: 'Kaarina', optionId: '58ce9cd9-7860-49a6-902e-2f98d1156a39' },
  { id: 'cities', name: 'Naantali', optionId: '1db5ec27-254f-44aa-a3da-6a649a3a3175' },
  { id: 'cities', name: 'Raisio', optionId: '1cfe7e8a-ee65-47ac-9913-b8f8c118c2c7' },
  { id: 'cities', name: 'Masku', optionId: '153c9e08-1c8e-4f91-a3fb-513b2a048190' },
  { id: 'cities', name: 'Nousiainen', optionId: '328c07ee-1943-4363-ae2d-87df665540cc' },
  { id: 'cities', name: 'Rusko', optionId: 'f84060ea-2251-4bd9-be09-0227df2c4f69' },
  { id: 'cities', name: 'Lieto', optionId: 'c3a0812b-e014-4413-9178-f450ecdc1dd2' },
  { id: 'cities', name: 'Aura', optionId: 'ffc17ce9-7642-4eab-87a5-3c8d77abea3d' },
  { id: 'cities', name: 'Marttila', optionId: '5a24e7a1-0d98-478b-b953-910ee97a8cae' },
  { id: 'cities', name: 'Paimio', optionId: 'f6a38419-6d97-4deb-9f69-df7870d7aaf6' },
  { id: 'cities', name: 'Sauvo', optionId: '8f3f40ee-1f0c-4300-ab95-8865e2f64e6d' },
  { id: 'cities', name: 'Parainen', optionId: '963b5d3e-1c99-4a02-a1b1-dd2369cc5dc6' },
  { id: 'cities', name: 'Pöytyä', optionId: '2d10df57-ced7-4dbc-8670-d22f88e7433b' },
  { id: 'cities', name: 'Mynämäki', optionId: 'e275b9f8-696c-40e9-ad36-258cd7a8915c' },
  { id: 'cities', name: 'Vehmaa', optionId: 'c2404d91-97f3-45b9-8654-7292f89a8dd1' },
  { id: 'cities', name: 'Taivassalo', optionId: '82b739bd-9cde-4064-b200-7616277e335d' },
  { id: 'cities', name: 'Kustavi', optionId: '9352b791-5962-4ced-960f-cc951ba8b64a' },
  { id: 'cities', name: 'Uusikaupunki', optionId: 'ba69ee9d-655e-480e-acc5-37df58219b35' },
  { id: 'cities', name: 'Laitila', optionId: '5036c42f-c3a3-4d55-9fc2-281f92468e30' },
  { id: 'cities', name: 'Pyhäranta', optionId: 'd2b27b4e-3f6f-45ff-8889-26571401d166' },
  { id: 'cities', name: 'Salo', optionId: '90f72060-52b6-47b0-9385-a0f235dddbd2' },
  { id: 'cities', name: 'Kemiönsaari', optionId: '892ad8ff-0d35-490f-a804-3fb3263488b0' },
  { id: 'cities', name: 'Somero', optionId: '3076ddd3-247c-4f37-adf6-20c4dd3797a0' },
  { id: 'cities', name: 'Koski Tl', optionId: '1f26a2e0-8e37-499f-8040-e8f4edfce24e' },
  { id: 'cities', name: 'Loimaa', optionId: 'd026e976-9433-4d0e-a2e6-c83d2583fac1' },
  { id: 'cities', name: 'Oripää', optionId: 'fa2144ab-0950-4332-a95b-b74b4690affa' },
  { id: 'cities', name: 'Maarianhamina - Mariehamn', optionId: '54329294-90a9-4db8-8156-da8714aab9c0' },
  { id: 'cities', name: 'Jomala', optionId: '6461092b-0552-4cc2-8b20-e78a17db1f3f' },
  { id: 'cities', name: 'Lemland', optionId: '8808a9fb-bd01-45bb-b634-13902b2fa744' },
  { id: 'cities', name: 'Finström', optionId: 'd14e7235-78e7-4f48-b4d2-75d13ce645f1' },
  { id: 'cities', name: 'Hammarland', optionId: '3e2b9756-cdb5-46b9-888e-835936526229' },
  { id: 'cities', name: 'Eckerö', optionId: '384e20f4-f4e1-4bd0-81c2-e521edfcff63' },
  { id: 'cities', name: 'Saltvik', optionId: '3821b7fb-ea84-4f49-a36a-f145035f5651' },
  { id: 'cities', name: 'Geta', optionId: 'a0a5c23c-9fda-4cfa-9fe1-d755004bb0f9' },
  { id: 'cities', name: 'Sund', optionId: 'f901ea68-f54d-45b0-b9fa-bc00d7d7f15d' },
  { id: 'cities', name: 'Vårdö', optionId: '68a53c10-2683-406b-ace7-56bd74e462ac' },
  { id: 'cities', name: 'Lumparland', optionId: 'f8c8c6d2-275c-4498-bd81-8778f6a50976' },
  { id: 'cities', name: 'Föglö', optionId: '7b21c8be-e6b3-4479-af38-671ebca00aa1' },
  { id: 'cities', name: 'Sottunga', optionId: 'e688e236-e15b-4d0e-8ab5-86ab95d56329' },
  { id: 'cities', name: 'Kökar', optionId: '990f4e70-d289-49c5-91e1-972a75c9ecf9' },
  { id: 'cities', name: 'Kumlinge', optionId: '6a1aa118-b0e9-4f0d-9923-4a08f6df3f9f' },
  { id: 'cities', name: 'Brändö', optionId: 'bdfd4e70-2ca9-496e-a17c-57211b85b845' },
  { id: 'cities', name: 'Rauma', optionId: 'a6cf22b3-5eeb-4942-bb0c-5a98f4da8392' },
  { id: 'cities', name: 'Eurajoki', optionId: 'bbed7f2e-57bb-4207-8b40-508d7f51e2d2' },
  { id: 'cities', name: 'Eura', optionId: 'ad499d91-6ce8-460a-a407-c2d35fd12d86' },
  { id: 'cities', name: 'Säkylä', optionId: '4dfc554d-4889-4d41-9626-4ee16c315c95' },
  { id: 'cities', name: 'Pori', optionId: '45423745-4f97-40c4-9edb-1f5a518d6f05' },
  { id: 'cities', name: 'Ulvila', optionId: '67f9c935-844b-491c-aa94-e26084baa73e' },
  { id: 'cities', name: 'Harjavalta', optionId: 'd54aff5b-b80f-4719-9717-b95ee9a7c42f' },
  { id: 'cities', name: 'Nakkila', optionId: 'c205b35c-80a0-422c-a930-a27d90320a02' },
  { id: 'cities', name: 'Pomarkku', optionId: '920dbcbc-495b-41a4-8622-9605540973d0' },
  { id: 'cities', name: 'Merikarvia', optionId: 'd2bc62c6-4fd2-404e-97ae-d96e5f7f2697' },
  { id: 'cities', name: 'Siikainen', optionId: '22167e21-af2f-4ad3-a459-9adbad98fada' },
  { id: 'cities', name: 'Huittinen', optionId: '151d1487-e89e-4b49-be2a-5a2a3c4aa2da' },
  { id: 'cities', name: 'Kokemäki', optionId: '96cd22f1-d04b-41da-acba-468a6769f4b0' },
  { id: 'cities', name: 'Kankaanpää', optionId: 'd6dd9650-046b-4135-bf27-1e523aba059d' },
  { id: 'cities', name: 'Jämijärvi', optionId: '9c5672bb-0c97-4205-9b96-beccc03b7697' },
  { id: 'cities', name: 'Honkajoki', optionId: '384556c0-8b55-42c4-afa9-0c84508051a0' },
  { id: 'cities', name: 'Karvia', optionId: '45c63a0c-0759-4ee4-9440-465ddf5c3b75' },
  { id: 'cities', name: 'Luumäki', optionId: 'ee48c196-da61-4a2c-9838-f8a921171ecc' },
  { id: 'cities', name: 'Lappeenranta', optionId: '3f4d353d-8861-470c-b0ce-4f268035a204' },
  { id: 'cities', name: 'Lemi', optionId: 'fee2740a-0e5e-4356-9089-441535036cbc' },
  { id: 'cities', name: 'Savitaipale', optionId: '4469bf56-0f50-46d6-9dd3-9d00749c56d2' },
  { id: 'cities', name: 'Taipalsaari', optionId: 'a686e3ec-82f4-4823-8011-4042d6f933e9' },
  { id: 'cities', name: 'Imatra', optionId: '2aa02fdf-195f-4cc8-88e9-43fb870a3cc0' },
  { id: 'cities', name: 'Ruokolahti', optionId: '99fa48b5-0fcf-4f2c-b496-cabf3de48311' },
  { id: 'cities', name: 'Rautjärvi', optionId: 'fed7e3e5-452e-41c3-ade0-c539dbbfeed6' },
  { id: 'cities', name: 'Parikkala', optionId: 'fb9e8393-e51b-40d1-80eb-e48b2d32fc57' },
  { id: 'cities', name: 'Kitee', optionId: 'c88da73e-57e3-4d0f-8b9d-befbade9f529' },
  { id: 'cities', name: 'Nurmes', optionId: '612abbdd-469b-4d7a-80ff-bdfe74d71957' },
  { id: 'cities', name: 'Joensuu', optionId: 'c22ac577-7a1b-45ad-9c5a-4eb8e93d6f93' },
  { id: 'cities', name: 'Liperi', optionId: 'a7df6b09-2517-4afd-8971-9510b87ae892' },
  { id: 'cities', name: 'Kontiolahti', optionId: 'c8e94e42-3cb0-4fc9-845f-1434add28939' },
  { id: 'cities', name: 'Ilomantsi', optionId: 'ba0bfaad-1b44-4854-805d-ac4770e024ff' },
  { id: 'cities', name: 'Lieksa', optionId: '00789c6e-c133-4401-ba17-f49f639df5c2' },
  { id: 'cities', name: 'Rääkkylä', optionId: '8d0ea8ef-32a6-416e-8c39-6970f9e93aca' },
  { id: 'cities', name: 'Tohmajärvi', optionId: '6f6251df-c836-4531-8369-4078a6095418' },
  { id: 'cities', name: 'Outokumpu', optionId: '586ab062-5304-4524-8ae3-99cf2f6b1453' },
  { id: 'cities', name: 'Polvijärvi', optionId: '8fb373b9-a906-4242-81b5-cba49949e618' },
  { id: 'cities', name: 'Juuka', optionId: 'e37fdf91-f923-46de-8f56-b811b35a5c95' },
  { id: 'cities', name: 'Seinäjoki', optionId: 'f8a14a57-ed94-4b39-a2ac-ab13c35ff7e5' },
  { id: 'cities', name: 'Ilmajoki', optionId: 'adc2f688-6a29-48e5-a7fa-20c1a580cb44' },
  { id: 'cities', name: 'Alavus', optionId: 'dbc5c328-e2bb-49d3-bcea-522652c8a98b' },
  { id: 'cities', name: 'Kurikka', optionId: '63e39512-ad4c-4db6-b22e-70bf710a666f' },
  { id: 'cities', name: 'Kauhajoki', optionId: '626835fb-4565-4460-a550-29028b335936' },
  { id: 'cities', name: 'Teuva', optionId: 'a3c1ed83-59cf-4a41-8bf6-b4c7c503ada6' },
  { id: 'cities', name: 'Lapua', optionId: '7a03d105-feee-4681-84ab-97890e943ae2' },
  { id: 'cities', name: 'Kauhava', optionId: 'ad2523ba-0fde-4371-992d-e17c8141940a' },
  { id: 'cities', name: 'Evijärvi', optionId: '4970b410-810f-43ca-a48f-6b5690e60849' },
  { id: 'cities', name: 'Lappajärvi', optionId: 'bedf018d-d78e-428c-a7b0-2988d677cdb9' },
  { id: 'cities', name: 'Alajärvi', optionId: '01ce65b1-bd25-4bc3-af35-dfa94ef7f09f' },
  { id: 'cities', name: 'Vimpeli', optionId: '84bbd504-4c7e-487e-a4f5-92f433ad0b76' },
  { id: 'cities', name: 'Kuortane', optionId: 'f4fca647-0e58-4cda-aa43-8b4ac36ab5b0' },
  { id: 'cities', name: 'Ähtäri', optionId: '80c5bbd2-1b67-46b8-9656-466bc02c19ba' },
  { id: 'cities', name: 'Soini', optionId: '49d05a68-5141-48cc-9469-5442e6defaf8' },
  { id: 'cities', name: 'Karijoki', optionId: 'e6fa6cf6-ece8-4bdb-a932-3f4c33178a7f' },
  { id: 'cities', name: 'Isojoki', optionId: 'ba5ae72a-7619-46b8-8c0a-fba3a7d3e8cb' },
  { id: 'cities', name: 'Isokyrö', optionId: 'f4cbc64a-db77-4819-b29c-d597c434c95e' },
  { id: 'cities', name: 'Vöyri', optionId: 'f494d4fb-4b1e-4bf9-ab75-8b726d699686' },
  { id: 'cities', name: 'Kristiinankaupunki', optionId: '3f980a2b-1f2a-4007-b855-a3a820bec1e9' },
  { id: 'cities', name: 'Närpiö', optionId: '6696323c-cae0-4650-aeb2-88803b1b208c' },
  { id: 'cities', name: 'Kaskinen', optionId: 'cf970703-1ca3-4f03-bbfd-e4d4c6bc1507' },
  { id: 'cities', name: 'Vaasa', optionId: '97368099-48a4-4435-918f-149822040c84' },
  { id: 'cities', name: 'Mustasaari', optionId: 'e63704e3-7a61-4979-ac10-922ee5afe417' },
  { id: 'cities', name: 'Maalahti', optionId: '9bf613f0-ef0d-47bf-bc6a-dc71ae6719e2' },
  { id: 'cities', name: 'Korsnäs', optionId: '826e0dae-00d5-4991-8a49-2cdd41077361' },
  { id: 'cities', name: 'Laihia', optionId: 'ccf1bbb5-25d6-4397-9168-81ef1c0f49df' },
  { id: 'cities', name: 'Uusikaarlepyy', optionId: 'fe3df722-fc03-4a6a-a322-d786b1fb60f8' },
  { id: 'cities', name: 'Kruunupyy', optionId: 'a3d56900-012e-497f-afd6-ebeb2304d6ce' },
  { id: 'cities', name: 'Pedersören kunta', optionId: '0821d583-2421-4745-b037-c267ee78191c' },
  { id: 'cities', name: 'Luoto', optionId: '255c36f2-840d-465c-9d40-cffbd093964d' },
  { id: 'cities', name: 'Pietarsaari', optionId: '10288771-5033-4d1a-933d-594b0e78bd24' },
  { id: 'cities', name: 'Kokkola', optionId: 'dc0257f9-1f45-4161-a3e0-803bc4dd0988' },
  { id: 'cities', name: 'Kannus', optionId: '58990774-9fa6-4536-82fc-590df09b683a' },
  { id: 'cities', name: 'Toholampi', optionId: '1f514788-5148-4d6d-a926-6ba81ea5b5e0' },
  { id: 'cities', name: 'Lestijärvi', optionId: '90ce792e-eddf-4b3f-a3d1-4a1c1f3ee3f5' },
  { id: 'cities', name: 'Halsua', optionId: '89410e89-3c6c-446b-b7ad-ffef7393c307' },
  { id: 'cities', name: 'Kaustinen', optionId: '79e8b095-2b91-41cd-94cb-3db9b3fa974a' },
  { id: 'cities', name: 'Veteli', optionId: '29906d1b-4390-47ad-832a-d86dc2fa721b' },
  { id: 'cities', name: 'Perho', optionId: 'e33e602e-cacf-4d70-83d0-edec490c2dee' },
  { id: 'cities', name: 'Kalajoki', optionId: '5881d768-71e5-4e70-a743-da070910e964' },
  { id: 'cities', name: 'Ylivieska', optionId: '89e82aad-7230-4f71-98a4-9d98e823f36f' },
  { id: 'cities', name: 'Alavieska', optionId: '88e1206c-476d-4359-b97b-89f5ec131bd8' },
  { id: 'cities', name: 'Sievi', optionId: 'c1eb588f-7775-40b9-af5d-575e081311ce' },
  { id: 'cities', name: 'Nivala', optionId: '8ab8e974-6d95-4ada-9fb1-e439eb34a195' },
  { id: 'cities', name: 'Haapajärvi', optionId: '95e1cf9f-cb90-4ec5-a4b3-3763517c5557' },
  { id: 'cities', name: 'Reisjärvi', optionId: 'da435681-f298-4006-95c3-aac3eae4c528' },
  { id: 'cities', name: 'Pyhäjoki', optionId: '1801cdbf-a09e-4d65-953b-a12aff596f97' },
  { id: 'cities', name: 'Oulainen', optionId: 'a24b1e97-b213-4f93-bc6c-126c877ffa47' },
  { id: 'cities', name: 'Merijärvi', optionId: '6cf4c0ac-8074-49bf-89b5-69a2c96e5f4d' },
  { id: 'cities', name: 'Raahe', optionId: 'd8995496-d52d-4a31-a0fd-7392ae00700c' },
  { id: 'cities', name: 'Haapavesi', optionId: '87006b66-2fe1-4a02-a5f4-1d751ce829b4' },
  { id: 'cities', name: 'Kärsämäki', optionId: '8eba5597-80dc-43e5-80d0-5df2e66846e9' },
  { id: 'cities', name: 'Pyhäjärvi', optionId: '9702db27-3240-4277-b90d-9e174b37ddc8' },
  { id: 'cities', name: 'Vaala', optionId: '96cc46cd-aa37-481e-aa8b-ae894973c38b' },
  { id: 'cities', name: 'Oulu', optionId: 'd9f63b48-047b-448e-aa11-0a56d2a26c5b' },
  { id: 'cities', name: 'Kempele', optionId: '9783a643-66ff-49cb-927f-3d8e1f184639' },
  { id: 'cities', name: 'Hailuoto', optionId: 'aaf0aba7-4e8f-461a-acd1-5ed62360fc1e' },
  { id: 'cities', name: 'Ii', optionId: '7c16f793-1011-4f59-98ab-f1d8af48f5be' },
  { id: 'cities', name: 'Muhos', optionId: '39a1564d-1761-4cec-a525-8792e535b833' },
  { id: 'cities', name: 'Utajärvi', optionId: 'b4b883af-7043-4697-9fcb-1f1ee78b021e' },
  { id: 'cities', name: 'Tyrnävä', optionId: '50cb18c8-4759-42e4-840d-c48f4791f927' },
  { id: 'cities', name: 'Liminka', optionId: '60a8bc50-59ad-4a89-bbc8-aa8bef6b033a' },
  { id: 'cities', name: 'Lumijoki', optionId: '14c74710-462b-4b77-b2cf-fc2b53ece67c' },
  { id: 'cities', name: 'Siikajoki', optionId: '85c0db2d-aaa3-42ba-8749-c908b3b7e902' },
  { id: 'cities', name: 'Siikalatva', optionId: '56dbdf82-f767-4486-a502-b1ab4caa6226' },
  { id: 'cities', name: 'Pyhäntä', optionId: '73b4e935-f8d9-4f30-a0b6-8c61770d959e' },
  { id: 'cities', name: 'Pudasjärvi', optionId: 'b507e571-c39e-4b63-b67a-b22f0fc62759' },
  { id: 'cities', name: 'Taivalkoski', optionId: '6718f551-4193-4900-b2ef-b94437276bcb' },
  { id: 'cities', name: 'Kuusamo', optionId: '382b4d89-8517-4bdb-9615-1ce9b53bb498' },
  { id: 'cities', name: 'Kuopio', optionId: '32e86f78-9a12-44ea-a157-f54d8458b590' },
  { id: 'cities', name: 'Siilinjärvi', optionId: '3ad1cdb3-fb6a-4aaa-afc2-35f53e08491e' },
  { id: 'cities', name: 'Tuusniemi', optionId: 'e0f18d18-2db1-4eba-8870-2b07e914f9ac' },
  { id: 'cities', name: 'Leppävirta', optionId: '6829da68-2429-4ddc-8d1b-6507e2efd320' },
  { id: 'cities', name: 'Tervo', optionId: '58425e5b-7d62-461b-8402-ba7a6911d901' },
  { id: 'cities', name: 'Lapinlahti', optionId: '2a4e97ba-7e6f-4dfc-a040-a21438edc92a' },
  { id: 'cities', name: 'Vesanto', optionId: '25b3965f-a77e-454f-bb2f-6259fbb36ff9' },
  { id: 'cities', name: 'Pielavesi', optionId: 'b04d0d96-60ee-4b26-935d-41ac857a9066' },
  { id: 'cities', name: 'Keitele', optionId: '2cc978d5-e0bf-41fc-bdf3-fafdcb91b235' },
  { id: 'cities', name: 'Kaavi', optionId: '08be6c76-b9b2-4607-9755-422cfc4301d4' },
  { id: 'cities', name: 'Rautavaara', optionId: '1a7cf61b-3543-4e47-aef3-0af3d08ccc26' },
  { id: 'cities', name: 'Iisalmi', optionId: '2f5c90a2-6de4-4154-a80f-9ababecc870e' },
  { id: 'cities', name: 'Vieremä', optionId: '59fa3a7d-04e1-486c-bdcc-b2e6d73921b5' },
  { id: 'cities', name: 'Sonkajärvi', optionId: '831a93d0-0021-4582-b5ef-ac3c9ada2bd8' },
  { id: 'cities', name: 'Kiuruvesi', optionId: 'f3fc1477-4b70-4aec-8da5-d43d81ceb713' },
  { id: 'cities', name: 'Suonenjoki', optionId: '2b6fc866-da6c-43c6-a241-7603228b2ebf' },
  { id: 'cities', name: 'Rautalampi', optionId: 'a5544cd6-724c-49e4-af98-85597b86b194' },
  { id: 'cities', name: 'Varkaus', optionId: '036b4655-9cbf-4bc8-a0f6-1e1642251089' },
  { id: 'cities', name: 'Sotkamo', optionId: 'a2a4b469-d9fd-4745-a4fb-2ed7da7c3293' },
  { id: 'cities', name: 'Kajaani', optionId: 'ad205cd7-7f3d-43fd-9c1b-c76e2e53e5b3' },
  { id: 'cities', name: 'Paltamo', optionId: '0e4cfba3-5d5d-4d25-9cbb-1a6706c67ae3' },
  { id: 'cities', name: 'Ristijärvi', optionId: '812d5687-7a05-4f6f-9448-9d4bca4d8b1a' },
  { id: 'cities', name: 'Kuhmo', optionId: '9b96c694-3ec2-40e9-a6e2-ba463f068545' },
  { id: 'cities', name: 'Puolanka', optionId: '10101429-7ccc-4649-9006-c30929f006b4' },
  { id: 'cities', name: 'Hyrynsalmi', optionId: '438b5d72-5dcf-4166-a33f-b01323ba5a84' },
  { id: 'cities', name: 'Suomussalmi', optionId: 'b9351af3-378f-49fc-972e-c8a18960b88b' },
  { id: 'cities', name: 'Kemi', optionId: 'df0eeb92-6b35-419d-bc59-7fb19b1b8659' },
  { id: 'cities', name: 'Keminmaa', optionId: 'ee6220e1-cc5d-4e87-9a34-184d950ce610' },
  { id: 'cities', name: 'Tornio', optionId: 'aedca613-b347-439d-99b0-582169f1c690' },
  { id: 'cities', name: 'Simo', optionId: 'a88b5429-a315-497c-981e-1d23ef76ff40' },
  { id: 'cities', name: 'Tervola', optionId: '416acf90-3f17-47cc-9f6c-3501656f1f5a' },
  { id: 'cities', name: 'Ylitornio', optionId: '83a4e2b8-bee6-4b1b-a4b4-03f48193fd38' },
  { id: 'cities', name: 'Pello', optionId: 'd1a46d64-1667-4cf1-8690-ef08072eff94' },
  { id: 'cities', name: 'Kolari', optionId: '978c7373-230d-4e3d-af7a-e70e2e4ed15f' },
  { id: 'cities', name: 'Muonio', optionId: '1c6d85f7-62c4-4db4-b928-21eea2d18ec5' },
  { id: 'cities', name: 'Rovaniemi', optionId: '69ca09d1-c865-4641-8255-1703104be9d5' },
  { id: 'cities', name: 'Sodankylä', optionId: '2e9f0f60-d448-473f-8fb9-ac30f13e18ac' },
  { id: 'cities', name: 'Kittilä', optionId: '7ce3a811-9967-4a99-bcdc-2baa4e0b59e3' },
  { id: 'cities', name: 'Kemijärvi', optionId: '2c5c93a3-e292-416d-b3be-093c4be93ff1' },
  { id: 'cities', name: 'Ranua', optionId: 'b7b90836-d905-4025-b3cb-00ecc415a301' },
  { id: 'cities', name: 'Posio', optionId: '010fe29f-47db-4bd1-b2e4-b77828968cb5' },
  { id: 'cities', name: 'Pelkosenniemi', optionId: '6f3fffe5-d8cc-4526-8d8b-095526c4ce7d' },
  { id: 'cities', name: 'Salla', optionId: 'a0a4df61-0abf-44c9-9c9a-3eea23f21eb5' },
  { id: 'cities', name: 'Savukoski', optionId: '7fed8e18-395a-4269-ad85-1f7b6d46ce56' },
  { id: 'cities', name: 'Enontekiö', optionId: '60826caf-089f-48e4-86e9-77bfe6475097' },
  { id: 'cities', name: 'Inari', optionId: 'db3bdc45-7d6a-4f1e-8c71-d384bc893c86' },
  { id: 'cities', name: 'Utsjoki', optionId: 'd7c464cf-46eb-4a5c-b898-64acc912f5c6' },
];

export const productTypeOptions = [
  { id: 'type', name: 'Experience', optionId: 'experience' },
  { id: 'type', name: 'Accommodation', optionId: 'accommodation' },
  { id: 'type', name: 'Rental Service', optionId: 'rental_service' },
  { id: 'type', name: 'Shop', optionId: 'shop' },
  { id: 'type', name: 'Restaurant', optionId: 'restaurant' },
  { id: 'type', name: 'Attraction', optionId: 'attraction' },
  { id: 'type', name: 'Event', optionId: 'event' },
];

export const tagOptions = [
  { id: 'tags', name: 'Bus', optionId: 'bus' },
  { id: 'tags', name: 'Taxi', optionId: 'taxi' },
  { id: 'tags', name: 'Waterbus / Ferry', optionId: 'waterbus_ferry' },
  {
    id: 'tags',
    name: 'Bed & breakfast, serviced apartment, guest house',
    optionId: 'bed_breakfast_apartments_guest_house',
  },
  { id: 'tags', name: 'Camping', optionId: 'camping' },
  { id: 'tags', name: 'Cottages & villas', optionId: 'cottages_villas' },
  { id: 'tags', name: 'Hotels & hostels', optionId: 'hotels_hostels' },
  { id: 'tags', name: 'Luxury accommodation', optionId: 'luxury_accommodation' },
  { id: 'tags', name: 'Northern lights accommodation', optionId: 'northern_lights_accommodation' },
  { id: 'tags', name: 'Specialty accommodation', optionId: 'specialty_accommodation' },
  { id: 'tags', name: 'Architecture', optionId: 'architecture' },
  { id: 'tags', name: 'Christmas & Santa', optionId: 'christmas_santa' },
  { id: 'tags', name: 'Creative arts', optionId: 'creative_arts' },
  { id: 'tags', name: 'Cultural heritage', optionId: 'cultural_heritage' },
  { id: 'tags', name: 'Events & festivals', optionId: 'events_festivals' },
  { id: 'tags', name: 'Finnish design and fashion', optionId: 'finnish_design_fashion' },
  { id: 'tags', name: 'History', optionId: 'history' },
  { id: 'tags', name: 'Local lifestyle', optionId: 'local_lifestyle' },
  { id: 'tags', name: 'Museums & galleries', optionId: 'museums_galleries' },
  { id: 'tags', name: 'Music', optionId: 'music' },
  { id: 'tags', name: 'Theater', optionId: 'theater' },
  { id: 'tags', name: 'Other performance arts', optionId: 'other_performance_arts' },
  { id: 'tags', name: 'Bars & nightlife', optionId: 'bars_nightlife' },
  { id: 'tags', name: 'Breweries & distilleries', optionId: 'breweries_distilleries' },
  { id: 'tags', name: 'Café', optionId: 'cafe' },
  { id: 'tags', name: 'Culinary experience', optionId: 'culinary_experience' },
  { id: 'tags', name: 'Fast food', optionId: 'fast_food' },
  { id: 'tags', name: 'Fine dining', optionId: 'fine_dining' },
  { id: 'tags', name: 'Food experience', optionId: 'food_experience' },
  { id: 'tags', name: 'Local food', optionId: 'local_food' },
  { id: 'tags', name: 'Lunch & brunch', optionId: 'lunch_and_brunch' },
  { id: 'tags', name: 'Restaurant', optionId: 'restaurant' },
  { id: 'tags', name: 'Vegetarian/Vegan', optionId: 'vegetarian_vegan' },
  { id: 'tags', name: 'Amusement park', optionId: 'amusement_park' },
  { id: 'tags', name: 'Animal parks & farms', optionId: 'animal_parks_farms' },
  { id: 'tags', name: 'Autumn colours (Ruska)', optionId: 'autumn_colours_ruska' },
  { id: 'tags', name: 'Camp school', optionId: 'camp_school' },
  { id: 'tags', name: "Children's attraction", optionId: 'childrens_attraction' },
  { id: 'tags', name: 'Coast & archipelago', optionId: 'coast_archipelago' },
  { id: 'tags', name: 'Cruises & ferries', optionId: 'cruises_ferries' },
  { id: 'tags', name: 'Family activity', optionId: 'family_activity' },
  { id: 'tags', name: 'Forests', optionId: 'forests' },
  { id: 'tags', name: 'Guided service', optionId: 'guided_service' },
  { id: 'tags', name: 'Handicraft', optionId: 'handicraft' },
  { id: 'tags', name: 'Historical sites', optionId: 'historical_sites' },
  { id: 'tags', name: 'Horses', optionId: 'horses' },
  { id: 'tags', name: 'Huskies', optionId: 'huskies' },
  { id: 'tags', name: 'Lakes', optionId: 'lakes' },
  { id: 'tags', name: 'Midnight sun', optionId: 'midnight_sun' },
  { id: 'tags', name: 'Motorsports', optionId: 'motorsports' },
  { id: 'tags', name: 'National park', optionId: 'national_park' },
  { id: 'tags', name: 'Natural site', optionId: 'natural_site' },
  { id: 'tags', name: 'Northern lights', optionId: 'northern_lights' },
  { id: 'tags', name: 'Parks & gardens', optionId: 'parks_gardens' },
  { id: 'tags', name: 'Photography', optionId: 'photography' },
  { id: 'tags', name: 'Private experience', optionId: 'private_experience' },
  { id: 'tags', name: 'Reindeer', optionId: 'reindeer' },
  { id: 'tags', name: 'Safari', optionId: 'safari' },
  { id: 'tags', name: 'Scenic point', optionId: 'scenic_point' },
  { id: 'tags', name: 'School visit', optionId: 'school_visit' },
  { id: 'tags', name: 'Sightseeing & tours', optionId: 'sightseeing_tours' },
  { id: 'tags', name: 'Sports', optionId: 'sports' },
  { id: 'tags', name: 'Swimming', optionId: 'swimming' },
  { id: 'tags', name: 'Tourist information', optionId: 'tourist_information' },
  { id: 'tags', name: 'Virtual reality', optionId: 'virtual_reality' },
  { id: 'tags', name: 'Other activity', optionId: 'other_activity' },
  { id: 'tags', name: 'Other attraction', optionId: 'other_attraction' },
  { id: 'tags', name: 'Berry & mushroom picking', optionId: 'berry_mushroom_picking' },
  { id: 'tags', name: 'Boating & sailing', optionId: 'boating_sailing' },
  { id: 'tags', name: 'Climbing', optionId: 'climbing' },
  { id: 'tags', name: 'Cycling & mountain biking', optionId: 'cycling_mountain_biking' },
  { id: 'tags', name: 'Disc golf', optionId: 'disc_golf' },
  { id: 'tags', name: 'Fishing & hunting', optionId: 'fishing_hunting' },
  { id: 'tags', name: 'Golf', optionId: 'golf' },
  { id: 'tags', name: 'Hiking, walking & trekking', optionId: 'hiking_walking_trekking' },
  { id: 'tags', name: 'Horseback riding', optionId: 'horseback_riding' },
  { id: 'tags', name: 'Minigolf', optionId: 'minigolf' },
  { id: 'tags', name: 'Nature excursion', optionId: 'nature_excursion' },
  { id: 'tags', name: 'Orienteering', optionId: 'orienteering' },
  { id: 'tags', name: 'Paddling & rafting', optionId: 'paddling_rafting' },
  { id: 'tags', name: 'Running & trailrunning', optionId: 'running_trailrunning' },
  { id: 'tags', name: 'Water activities', optionId: 'water_activities' },
  { id: 'tags', name: 'Wildlife & bird watching', optionId: 'wildlife_bird_watching' },
  { id: 'tags', name: 'Billiards', optionId: 'billiards' },
  { id: 'tags', name: 'Bowling', optionId: 'bowling' },
  { id: 'tags', name: 'Indoor playground', optionId: 'indoor_playground' },
  { id: 'tags', name: 'Virtual arcade', optionId: 'virtual_arcade' },
  { id: 'tags', name: 'Other indoor activities', optionId: 'other_indoor_activities' },
  { id: 'tags', name: 'Cross-country skiing', optionId: 'cross_country_skiing' },
  { id: 'tags', name: 'Ice climbing', optionId: 'ice_climbing' },
  { id: 'tags', name: 'Ice fishing', optionId: 'ice_fishing' },
  { id: 'tags', name: 'Ice skating', optionId: 'ice_skating' },
];

export const seasonOptions = [
  { id: 'season', name: 'January', optionId: 'january' },
  { id: 'season', name: 'February', optionId: 'february' },
  { id: 'season', name: 'March', optionId: 'march' },
  { id: 'season', name: 'April', optionId: 'april' },
  { id: 'season', name: 'May', optionId: 'may' },
  { id: 'season', name: 'June', optionId: 'june' },
  { id: 'season', name: 'July', optionId: 'july' },
  { id: 'season', name: 'August', optionId: 'august' },
  { id: 'season', name: 'September', optionId: 'september' },
  { id: 'season', name: 'October', optionId: 'october' },
  { id: 'season', name: 'November', optionId: 'november' },
  { id: 'season', name: 'December', optionId: 'december' },
];

export const targetOptions = [
  // { id: 'target', name: 'Individual', optionId: 'individual' },
  // { id: 'target', name: 'Group', optionId: 'group' },
  { id: 'target', name: 'B2C', optionId: 'b2c' },
  { id: 'target', name: 'B2B (tour operator)', optionId: 'b2b' },
];

export const checkboxOptions = [
  { name: 'Sustainable Travel Finland', id: 'sustainable' },
  { name: 'Accessible', id: 'accessible' },
];
